import { render, staticRenderFns } from "./supportIcon.vue?vue&type=template&id=5fca9888&"
import script from "./supportIcon.vue?vue&type=script&lang=js&"
export * from "./supportIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports